import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import BrandLogo from './BrandLogo';

const NAV_LINKS = [
  { label: 'Home', href: '#home' },
  { label: 'Services', href: '#services' },
  { label: 'How It Works', href: '#how-it-works' },
  { label: 'Contact Us', href: '#contact' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const navRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    const handleEscape = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, []);

  const handleNavClick = () => setOpen(false);

  return (
    <motion.nav
      className="navbar navbar--hero"
      ref={navRef}
      initial={{ opacity: 0, y: -18 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
    >
      <a href="#home" className="brand brand--hero">
        <BrandLogo variant="text" tone="light" />
      </a>

      <ul className="nav-links nav-links--desktop">
        {NAV_LINKS.map((item) => (
          <li key={item.label}>
            <a href={item.href}>{item.label}</a>
          </li>
        ))}
      </ul>

      <a href="#get-app" className="nav-cta">
        Get the App
      </a>

      <div className="nav-menu-wrap">
        <button
          type="button"
          className={`nav-hamburger nav-hamburger--hero${open ? ' nav-hamburger--open' : ''}`}
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
          aria-controls="nav-dropdown"
          onClick={() => setOpen((prev) => !prev)}
        >
          <span />
          <span />
          <span />
        </button>

        <ul id="nav-dropdown" className={`nav-dropdown${open ? ' nav-dropdown--open' : ''}`}>
          {NAV_LINKS.map((item) => (
            <li key={item.label}>
              <a href={item.href} onClick={handleNavClick}>
                {item.label}
              </a>
            </li>
          ))}
          <li>
            <a href="#get-app" className="nav-dropdown-cta" onClick={handleNavClick}>
              Get the App
            </a>
          </li>
        </ul>
      </div>
    </motion.nav>
  );
}
